/**LAGOSCarbonStrategy — /state/lagos/carbon-strategy */
import React, { useState } from "react";
import { useLagos } from "@/context/LAGOSContext";
import { PageHeader, SectionCard } from "@/components/ds";

const STRATEGY={standalone:{label:"Standalone Project",color:"#059669",bg:"#ecfdf5",why:["High reduction potential (>500 tCO₂e)","Sufficient evidence quality","VCM eligible"]},cpa:{label:"CPA Candidate",color:"#1d4ed8",bg:"#eff6ff",why:["Part of sector cluster","Grouped with 3+ similar entities","Methodology aligned"]},vcm:{label:"VCM Pathway",color:"#d97706",bg:"#fffbeb",why:["50-499 tCO₂e reduction","VCM methodology eligible","Phase 2 engagement needed"]},internal:{label:"Internal Action",color:"#64748b",bg:"#f8fafc",why:["Below VCM threshold","Improve evidence first","Upskilling / TA required"]}};

const fmtN=(v,u="")=>{ if(!v&&v!==0)return"—"; const n=Number(v); if(n>=1000)return`${(n/1000).toFixed(0)}K ${u}`.trim(); return`${n.toLocaleString()} ${u}`.trim(); };

export default function LAGOSCarbonStrategy() {
  const { portfolio, loading } = useLagos();
  const [view, setView] = useState("all");
  const opps = (portfolio.top_opportunities||[]).filter(o =>
    view==="all" || o.carbon_pathway===view
  );
  if (loading) return <div className="p-8 text-slate-400 text-sm">Loading…</div>;
  return (
    <div className="p-6 lg:p-8 bg-[#F8FAFC] min-h-screen space-y-5">
      <PageHeader label="CARBON STRATEGY" title="" />
      <p className="text-xs text-slate-400 -mt-4">Pathway classification · Quick wins · CPA candidates · PoA candidates · Internal actions</p>
      <div className="flex gap-2 flex-wrap">
        {[["all","All"],["standalone","Standalone"],["cpa","CPA Candidates"],["vcm","VCM"],["internal","Internal"]].map(([v,l])=>(
          <button key={v} onClick={()=>setView(v)} className={`text-xs px-3 py-1.5 rounded-lg border ${view===v?"bg-[#1d4ed8] text-white border-[#1d4ed8]":"bg-white text-slate-500 border-slate-200"}`}>{l}</button>
        ))}
      </div>
      <div className="space-y-3">
        {opps.map((o,i)=>{
          const s=STRATEGY[o.carbon_pathway]||STRATEGY.internal;
          return (
            <div key={o.entity_id} className="bg-white rounded-xl border shadow-sm p-4" style={{borderLeft:`3px solid ${s.color}`}} data-testid={`strategy-${i}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className="text-xs font-black text-slate-800">{o.name}</span>
                    <span className="text-[10px] px-2 py-0.5 rounded-full font-bold" style={{background:s.bg,color:s.color}}>{s.label}</span>
                    {o.art6_eligible?<span className="text-[10px] px-1.5 py-0.5 rounded bg-blue-50 text-blue-700 font-bold">Art.6.4</span>:null}
                  </div>
                  <p className="text-xs text-slate-400">{o.lga} · {(o.sector||"").replace(/_/g," ").replace(/\b\w/g,c=>c.toUpperCase())}</p>
                </div>
                <div className="text-right ml-4">
                  <p className="text-sm font-black text-emerald-700">{fmtN(o.reduction_potential_tco2e,"tCO₂e/yr")}</p>
                  <p className="text-[10px] text-slate-400">Score: {(o.composite_score||0).toFixed(0)}</p>
                </div>
              </div>
              <div className="mt-2 flex gap-2 flex-wrap">
                {s.why.map(w=><span key={w} className="text-[10px] px-2 py-0.5 bg-slate-50 rounded text-slate-500 border border-slate-100">{w}</span>)}
              </div>
            </div>
          );
        })}
        {opps.length===0&&<div className="text-xs text-slate-400 p-6 text-center bg-white rounded-xl border">No entities match this filter</div>}
      </div>
    </div>
  );
}
